let html = `<div class="full-review selector layer--visible">
    <div class="full-review__text">{text}</div>

    <div class="full-review__footer">#{full_like}: {like_count}</div>
</div>`

export default html